import { isValidURL } from "../../../../helpers";
import { WIZARD_ERROR_MESSAGE } from "../../../wizard/constants";
import { TValidator, WizardMode } from "../../../wizard/types";
import { IAcademicFormModelSecondary } from "../../types";
import { isLevelHasAcademic } from "./hooks/useAcademicConfig";

const validator: TValidator = async ({
  values,
}: {
  values: IAcademicFormModelSecondary;
}) => {
  if (isLevelHasAcademic(values) && values.mode === WizardMode.Create) {
    return;
  }

  const errors: {
    [key: string]: any;
  } = {};

  const schoolLevelId = values.selectedSchoolLevel.id;
  const schoolLevel = values.schoolLevels?.[values.selectedSchoolLevel.id];

  if (
    schoolLevelId === "_3" &&
    !schoolLevel.schoolGrade &&
    !schoolLevel.otherGrade
  ) {
    throw {
      [WIZARD_ERROR_MESSAGE]: "School Grade is required",
    };
  }

  if (!schoolLevel?.schoolType) {
    errors.schoolType = "School Type is required";
  }

  if (
    !schoolLevel ||
    !schoolLevel.requiredDocs ||
    schoolLevel.requiredDocs.length < 2
  ) {
    errors.requiredDocs = "Please select at least 2";
  }

  if (
    schoolLevel?.applicationLink &&
    !isValidURL(schoolLevel.applicationLink)
  ) {
    errors.applicationLink = "Please insert a valid URL";
  }

  if (Object.keys(errors).length > 0) {
    throw {
      schoolLevels: {
        [schoolLevelId]: errors,
      },
    };
  }
};

export default validator;
